var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"users-body"},[_vm._v(" "+_vm._s(_vm.isLoading)+" "),_c('Loader')],1):_c('div',{staticClass:"su-content su-lots-content"},[_c('Tabs',{attrs:{"tabs":_vm.tabs,"lotsCount":_vm.getLotsCount}}),_c('router-view',{attrs:{"showOnlyAuct":_vm.showOnlyAuct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }